import { Injectable } from '@angular/core';
import { getApp } from 'firebase/app';
import { doc, getDoc, getFirestore, setDoc } from 'firebase/firestore';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  isOrg: boolean = false;
  org !: string

  setOrg(org: string) {
    this.org = org
  }

  getOrgStatus() {
    return this.isOrg;
  }

  addOrgInfo(name: string, description: string, interests: string[]) {
    const firestoreDB = getFirestore(getApp());
    const orgsCollection = doc(firestoreDB, "Organizations", this.org);
    const orgData = {
      name: name,
      description: description,
      interests: interests,
    }

    setDoc(orgsCollection, orgData)
      .then(userData => {
        console.log("organization added!");
      })
      .catch(error => {
        console.log(error);
      })
  }

  async checkIfOrg(email: string) {
    const firestoreDB = getFirestore(getApp());
    const username = email.split("@")[0];
    const docRef = doc(firestoreDB, "Organizations", username);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      console.log("you are an org is true")
      //this email is in our user collection.
      this.isOrg = true;
    }
    else {
    }
  }

  async getOrg(org: any) {
    const orgRef = doc(getFirestore(getApp()), "Organizations", org);
    const orgSnap = await getDoc(orgRef);
    if (!orgSnap.exists()) {
      return null;
    }
    let data: { name: string, tags: string[], description: string } = {
      name: orgSnap.get("name"),
      tags: orgSnap.get("interests"),
      description: orgSnap.get("description")
    }
    return data;
  }
}
